// extracted by mini-css-extract-plugin
export default {"modalOverlay":"KC-z","modalContent":"LC-z","header":"MC-z","close":"NC-z"};